export interface Flight {
  duration: number;
  legs: Leg[];
  extraLuggage?: Luggage;
}

export interface UnspecifiedFlight {
  airlines: Airline[];
  departureCity: string;
  arrivalCity: string;
  departureTime: string;
  arrivalTime: string;
  departureDate: string;
  arrivalDate: string;
  directFlight: boolean;
  luggage: Luggage;
  handLuggage: HandLuggage;
}

export interface Airline {
  iata: string;
  id: number;
  name: string;
}

export interface Airport {
  city: string;
  iata: string;
  id: number;
  name: string;
  timezone: string;
}

export enum AirplaneType {
  Regular = 'regular',
  BlackJet = 'black-jet',
}

export enum Direction {
  There = 'there',
  Back = 'back',
}

export enum FlightType {
  Regular = 'regular',
  Charter = 'charter',
  Mixed = 'mixed',
  Unknown = 'unknown',
}

export enum FlightClass {
  Economy = 'economy',
  Business = 'business',
  Comfort = 'comfort',
  First = 'first',
  BlackJet = 'black-jet',
}

export enum ConnectingFlightType {
  SameAirport = 'same-airport',
  OtherAirport = 'other-airport',
}

export interface ConnectingFlight {
  type: ConnectingFlightType;
  waitingTime: number;
}

export enum LuggageStatus {
  Unknown = 'unknown',
  Included = 'included',
  NotIncluded = 'not-included',
}

export enum LuggageType {
  Luggage = 'luggage',
  HandLuggage = 'handLuggage',
}

export enum Point {
  Departure = 'departure',
  Arrival = 'arrival',
}

export interface Luggage {
  places: number | null;
  weight: number | null;
  status?: LuggageStatus;
  price?: number;
}

export interface LuggageDimensions {
  width: number;
  height: number;
  length: number;
}

export interface HandLuggage extends Luggage {
  dimensions?: LuggageDimensions | null;
}

export enum ModificationOptionType {
  Change = 'change',
  Refund = 'refund',
}

export enum ChangePolicy {
  Free = 'free',
  Paid = 'paid',
  Unavailable = 'unavailable',
  Unknown = 'unknown',
}

export interface Leg {
  id: string;
  airline: Airline;
  airportArrival: Airport;
  airportDeparture: Airport;
  type: FlightType;
  class: FlightClass;
  flightNumber: string;
  departureDate: string;
  arrivalDate: string;
  duration: number;
  luggage: Luggage;
  handLuggage: HandLuggage;
  connecting?: ConnectingFlight;
  airplaneType?: AirplaneType;
  refund?: ChangePolicy;
  change?: ChangePolicy;
  tariffName?: string | null;
}

export function isSpecifiedFlight(flight: Flight | UnspecifiedFlight | null): flight is Flight {
  return flight !== null && 'legs' in flight;
}
